import React, { useState, useEffect } from 'react';
import './styles.css';
import { useHistory } from 'react-router';
import { Row, Col, Button, Form } from 'antd';
import {
  DividerContainer,
  PageLayout,
  CollapseData,
  InputForm,
  ButtonBackData,
  ActivationRoleDescription,
} from '@BUP/components';
import { useDataFormPage } from '@BUP/hooks';
import { useTranslation } from 'react-i18next';

const DataStartActivationPage = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const [, forceUpdate] = useState();
  const DataFormValues = useDataFormPage();
  const { students, teachers, assistants, parents } = DataFormValues.formValues;
  const {
    minParents,
    minStudents,
    minTeachers,
    minAssistants,
  } = DataFormValues.minValues;
  const [t] = useTranslation();

  const handleFormSubmit = () => {
    // console.log("values," values)
    if (students >= 0 && parents >= 0 && teachers >= 0 && assistants >= 0) {
      history.push(
        '/data/instruments/request-activation/start-activation/terms-and-conditions'
      );
    }
  };
  useEffect(() => {
    forceUpdate({});
  }, []);

  return (
    <PageLayout>
      <ButtonBackData onClick={() => history.goBack()} />
      <DividerContainer title={t('pages.data.startActivation.dividerTitle')} />
      <h3 className="title">{t('pages.data.startActivation.title')}</h3>
      <p className="start-activation_paragraph">
        {t('pages.data.startActivation.introText')}
      </p>
      <Row>
        <Col span={24} style={{ marginTop: 20 }}>
          <Row>
            <ActivationRoleDescription
              name={t('pages.data.startActivation.studentsTitle')}
              description={t('pages.data.startActivation.studentsDescription')}
            />
            <ActivationRoleDescription
              name={t('pages.data.startActivation.parentsTitle')}
              description={t('pages.data.startActivation.parentsDescription')}
            />
            <ActivationRoleDescription
              name={t('pages.data.startActivation.teachersTitle')}
              description={t('pages.data.startActivation.teachersDescription')}
            />
            <ActivationRoleDescription
              name={t('pages.data.startActivation.assistantsTitle')}
              description={t(
                'pages.data.startActivation.assistantsDescription'
              )}
            />
          </Row>
        </Col>
        <Form
          layout="inline"
          onFinish={handleFormSubmit}
          form={form}
          initialValues={{
            students,
            teachers,
            assistants,
            parents,
          }}
          onFieldsChange={(values) =>
            DataFormValues.handleInputChange(values[0])
          }
        >
          <Col span={24} style={{ marginTop: 10 }}>
            <Row>
              <InputForm
                autoFocus
                name="students"
                value={students}
                onChange={DataFormValues.handleInputChange}
              />
              <InputForm
                name="parents"
                value={parents}
                onChange={DataFormValues.handleInputChange}
              />
              <InputForm
                name="teachers"
                value={teachers}
                onChange={DataFormValues.handleInputChange}
              />
              <InputForm
                name="assistants"
                value={assistants}
                onChange={DataFormValues.handleInputChange}
              />
            </Row>
          </Col>
          <Col span={24} style={{ marginTop: 30 }}>
            <Row justify="center">
              <Col span={24}>
                <CollapseData
                  header={t('pages.data.startActivation.collapseHeader')}
                  text1={minStudents !== null ? minStudents : ''}
                  text2={minParents !== null ? minParents : ''}
                  text3={minTeachers != null ? minTeachers : ''}
                  text4={minAssistants !== null ? minAssistants : ''}
                />
              </Col>
            </Row>
          </Col>
          {form.getFieldsError().filter(({ errors }) => errors.length)
            .length ? (
            <Col span={22}>
              <h3 className="text-warning">
                <span className="text-warning_span">
                  {t('pages.data.startActivation.warningSpan')}
                </span>{' '}
                {t('pages.data.startActivation.warningText')}
              </h3>
            </Col>
          ) : null}
          <Col span={24} align="center" className="startActivation_col__button">
            <Form.Item shouldUpdate>
              {() => (
                <Button
                  className="continue-button"
                  type="primary"
                  htmlType="submit"
                  disabled={
                    form.getFieldsError().filter(({ errors }) => errors.length)
                      .length
                  }
                >
                  {t('pages.data.startActivation.activationButtonText')}
                  <br />
                  <b>
                    {t('pages.data.startActivation.activationButtonBoldText')}
                  </b>
                </Button>
              )}
            </Form.Item>
          </Col>
        </Form>
      </Row>
    </PageLayout>
  );
};

export default DataStartActivationPage;
